import type { RouteRecordRaw } from 'vue-router';

/** Platform news (read-only for tenants). */
export const newsRoutes: RouteRecordRaw[] = [
  {
    path: 'news',
    name: 'news',
    component: () => import('./pages/NewsListPage.vue'),
    meta: { title: 'News', requiresAuth: true },
  },
  {
    path: 'news/:slug',
    name: 'news.show',
    component: () => import('./pages/NewsDetailPage.vue'),
    meta: { title: 'News', requiresAuth: true },
  },
];
